<template>
  <!-- Il titolo della pagina sta nell'header (AdminTopHeader) -->
  <div>
    <div class="filter-bar shadowedCard">
      <div class="filter-bar__field">
        <label class="filter-bar__label" for="report-select">Report</label>
        <b-form-select
          id="report-select"
          v-capitalize-first-select
          v-model="selected"
        >
          <b-form-select-option disabled value="">
            Seleziona un report
          </b-form-select-option>
          <b-form-select-option value="1">
            Registrazioni, servizi e progetti
          </b-form-select-option>
          <b-form-select-option value="2">
            Crescita degli iscritti
          </b-form-select-option>
          <b-form-select-option value="3">
            Monitoraggio attività del cittadino
          </b-form-select-option>
        </b-form-select>
      </div>
    </div>

    <!-- Nessun report scelto -->
    <div v-if="!selected" class="empty-state">
      <b-icon class="empty-state__icon" icon="file-bar-graph" aria-hidden="true"></b-icon>
      <p>Scegli un report per vederne i dati.</p>
    </div>

    <!-- Caricamento -->
    <div v-else-if="loading" class="empty-state">
      <b-spinner variant="secondary" label="Caricamento"></b-spinner>
      <p>Caricamento del report in corso...</p>
    </div>

    <!-- Il report -->
    <div v-else-if="selected && iframeUrl" class="shadowedCard p-2">
      <div class="report-frame">
        <iframe
          :src="iframeUrl"
          frameborder="0"
          allowtransparency
          loading="lazy"
          title="Reports"
        ></iframe>
      </div>
    </div>

    <!-- Il report non si carica -->
    <div
      v-else-if="selected && !iframeUrl && !loading"
      class="empty-state empty-state--danger"
    >
      <b-icon
        class="empty-state__icon"
        icon="exclamation-triangle"
        aria-hidden="true"
      ></b-icon>
      <p>Impossibile caricare il report. Riprova più tardi.</p>
    </div>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { adminService } from '@/_services'

const selected = ref('')
const iframeUrl = ref('')
const loading = ref(false)

// Mappa dashboard ID per ogni report
const dashboardMap = {
  '1': 3, // Registrazioni, servizi e progetti
  '2': 2, // Crescita degli iscritti
  '3': 4  // Monitoraggio attività del cittadino
}

// Watch per il cambio di selezione
watch(selected, async (newValue) => {
  if (!newValue) {
    iframeUrl.value = ''
    return
  }

  loading.value = true
  
  try {
    const dashboardId = dashboardMap[newValue]
    // console.log(`Report ${newValue} selected - Dashboard ID: ${dashboardId}`)
    const response = await adminService.getMetabaseEmbedUrl(dashboardId, {})
    iframeUrl.value = response.data.embedUrl
  } catch (error) {
    console.error('Errore nel caricamento del report:', error)
    iframeUrl.value = ''
  } finally {
    loading.value = false
  }
})


</script>

<style scoped>
/* La cornice del report tiene la proporzione: larga sul monitor, alta sul
   telefono. Il resto (superficie, raggio) lo porta .shadowedCard. */
.report-frame iframe {
  aspect-ratio: 16 / 9;
  width: 100%;
  border: 0;
}
@media (max-width: 960px) {
  .report-frame iframe {
    aspect-ratio: 3 / 4;
  }
}
</style>